let formatDate=(date)=>{
    let da= new Date(date);
    let month=`${da.getMonth()+1}`;
    let day=`${da.getDate()}`;
    let year=da.getFullYear();

    if(month.length<2){
        month=`0${month}`
    }
    if(day.length<2){
        day=`0${day}`
    }

    return[year, month, day].join('-');
}

export default formatDate;